import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../../context/NotificationContext';
import { createPortal } from 'react-dom';
// Use project's FontAwesome React component for consistent icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faBox, faTruck, faBell, faDollarSign, 
  faChartLine,
  faEllipsisV,faChevronRight , faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';
import { decryptData } from '../../../utils/storageCrypto';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../../Messages/Messages';


 export default function ActionCenter({ onViewClick, onNewNotification}) {
  const navigate = useNavigate();
  const { notifications, setNotifications } = useNotification();
  console.log("notifications from context in action center:", notifications);
  
  const [actions, setActions] = useState([]);
  const [loadingIds, setLoadingIds] = useState([]);

  // Refresh state: when notifications update, clear old actions and show refreshing for 1s
  const [refreshing, setRefreshing] = useState(false);
  const refreshTimerRef = useRef(null);
  const isInitialMount = useRef(true);
  const [showPopupMessages, setShowPopupMessages] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
    const [retryFunction, setRetryFunction] = useState(null);
    const [Loading, setIsLoading] = useState(false);
const lastProcessedCount = useRef(0);



useEffect(() => {

  if (!notifications || notifications.length === 0) {
    setActions([]);
    return;
  }

  const enuserId = sessionStorage.getItem('userId');
  const userId = decryptData(enuserId);

  const filteredNotifications = notifications.filter(notification =>
    String(notification.recipientId ?? notification.data?.recipientId) === String(userId)
  );

  const mapped = filteredNotifications
    .filter(n => n?.active === true || n?.data?.active === "true")
    .sort((a, b) =>
      new Date(b.createdAt || b.timestamp) -
      new Date(a.createdAt || a.timestamp)
    )
    .map((n, idx) => {

      const data = n.data || {};

      const entity =
        String(
          n?.metadata?.entity ||
          n?.data?.entity ||
          n?.entity ||
          ''
        ).toLowerCase();

      let entityId =
        n?.metadata?.entityId ||
        n?.data?.entityId ||
        n?.entityId ||
        null;

      if (typeof entityId === "string") {
        entityId = entityId.replace(/^"+|"+$/g, '');
      }

      const status = (
        data.status ||
        data.order_status ||
        data.in_fulfillment_status ||
        ''
      ).toLowerCase();

      let requiresAction = 'View Details';

      if (status.includes('respond')) requiresAction = 'Respond Now';
      else if (entity === 'rfq' && status.includes('quote')) requiresAction = 'Submit Quote';
      else if (entity === 'order' && (status.includes('ready') || status.includes('awaiting')))
        requiresAction = 'Respond Now';
      else if (entity === 'delivery') requiresAction = 'View Delivery';

      return {
        id: `${n.timestamp || n.createdAt || Date.now()}-${idx}`,
        title: n.title || entity.toUpperCase() || 'Notification',
        description: n.body || n.what || status,
        priority: status.includes('urgent') ? 'high' : 'medium',
        timestamp: n.timestamp || n.createdAt,
        requiresAction,
        entity,
        entityId,
        raw: n,
      };

    });



  setActions(mapped);
 

}, [notifications]);

useEffect(() => {
  if (isInitialMount.current) {
    isInitialMount.current = false;
    return;
  }
  setRefreshing(true);
  const t = setTimeout(() => {
    setRefreshing(false);
  }, 600);

  onNewNotification?.();

  return () => clearTimeout(t);
}, [notifications?.length]);


//   useEffect(() => {
//   if (!Array.isArray(notifications) || notifications.length === 0) {
//     fetchData();
//    } else {
//      fetchData(); 
//    }
// }, [notifications]);

useEffect(() => {
  const currentCount = Array.isArray(notifications) ? notifications.length : 0;

  if (currentCount === 0 || currentCount !== lastProcessedCount.current) {
    
    lastProcessedCount.current = currentCount;
    
    fetchData();
  }
}, [notifications?.length]); 
 
  const closePopup = () => {
    setShowPopupMessages(false);
  };
  
  const Retry = async () => {
    setIsLoading(true); // Show loader
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction(); // Call retry function
      }
      setIsLoading(false); // Hide loader after retry
    }, 5000); // 5-second delay
    setShowPopupMessages(false);
  };
  
  const BackToLoginPage = () => {

    setShowPopupMessages(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };


const fetchData = async () => {
  const URL = process.env.REACT_APP_FORE_NOTIFY;

  try {
    const enrecipientId = sessionStorage.getItem('userId');
    const enrecipientRole = sessionStorage.getItem('roleId');
    const encryptedToken = sessionStorage.getItem('token');
    console.log(enrecipientId, enrecipientRole, encryptedToken);
    if (!enrecipientId || !enrecipientRole || !encryptedToken) {
      setPopupMessage("Session expired. Please login again.");
      setPopupType("401");
      setShowPopupMessages(true);
      return;
    }

    const recipientId = decryptData(enrecipientId);
    const recipientRole = decryptData(enrecipientRole);
    const token = decryptData(encryptedToken);

    console.log("decrpted:", recipientId, recipientRole, token);

    if (!recipientId || /* !recipientRole || */ !token) {
      setPopupMessage("Invalid session data. Please login again.");
      setPopupType("401");
      setShowPopupMessages(true);
      return;
    }

    const response = await fetch(
      `${URL}notifications/get-all-active-notifications?recipientId=${recipientId}&recipientRole=${recipientRole}`,
      {
        headers: {
          'x-token': token
        }
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      setPopupMessage(errorData.message || "Failed to fetch notifications");
      setPopupType(response.status === 401 ? "401" : response.status === 403 ? "403" : "400");
      setShowPopupMessages(true);
      setRetryFunction(() => fetchData);
      return;
    }

    const data = await response.json();

    if (data.success) {
      setNotifications(data.notifications || []);
    } else {
      setPopupMessage(data.message || "Failed to load notifications");
      setPopupType("400");
      setShowPopupMessages(true);
      setRetryFunction(() => fetchData);
    }

  } catch (err) {
    setPopupMessage(err.message || "Something went wrong");
    setPopupType("500");
    setShowPopupMessages(true);
    setRetryFunction(() => fetchData);
  }
};




  // Use FontAwesome React component (icons imported above)
  const getIcon = (type) => {
    if (type === 'rfq') {
      return (
        <div className="w-5 h-5 bg-red-500 rounded flex items-center justify-center flex-shrink-0">
          <FontAwesomeIcon icon={faFileAlt} className="w-3 h-3 text-white" />
        </div>
      );
    }
    if (type === 'order') {
      return (
 <div className="w-5 h-5 bg-blue-500 rounded flex items-center justify-center flex-shrink-0"> 
          <FontAwesomeIcon icon={faDollarSign} className="w-4 h-4 text-white" />
        </div>
      );
    }
    if (type === 'delivery') {
      return (
        <div className="w-5 h-5 bg-orange-500 rounded flex items-center justify-center flex-shrink-0">
          <FontAwesomeIcon icon={faTruck} className="w-4 h-4 text-white" />
        </div>
      );
    }
   
    // fallback bell icon
    return (
      <div className="w-5 h-5 bg-gray-500 rounded flex items-center justify-center flex-shrink-0">
        <FontAwesomeIcon icon={faBell} className="w-4 h-4 text-white" />
      </div>
    );
  };

  const getPriorityColor = (priority) => {
    if (priority === 'high') return 'bg-red-100 text-red-600';
    if (priority === 'medium') return 'bg-yellow-100 text-yellow-600';
    if (priority === 'low') return 'bg-blue-100 text-blue-600';
    return 'bg-gray-100 text-gray-700';
  };

  // Loading helpers (for showing spinner when an action is clicked)
  const startLoading = (id) => {
    setLoadingIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
  };
  const stopLoading = (id) => {
    setLoadingIds((prev) => prev.filter((x) => x !== id));
  };
  const isLoading = (id) => loadingIds.includes(id);

  const handleAction = (action) => {
    startLoading(action.id);
    console.log("action:::",action)

     if (typeof onViewClick === 'function') {
    onViewClick();
  }

  console.log("action:::", action);
    // Determine navigation target based on entity and id
    const { entity, entityId, raw } = action;
    if (!entityId) {
      alert('No entity id in notification');
      stopLoading(action.id);
      return;
    }

    if (entity === 'rfq') {
      console.log("when entity is rfq then entityid is :",entityId)
      navigate('/bb/app/rfqfullfillmentflow', { state: { rfq_id: entityId, activeTab:'rfqs' } });
      //navigate('/bb/app/home', { state: { rfq_id: entityId, activeTab:'rfqs' } });
    } else if (entity === 'order') {
      //navigate('/bb/app/orderfullfillmentflow', { state: { order_id: entityId, activeTab:'orders' } });
      navigate('/bb/app/home', { state: { order_id: entityId, activeTab:'orders' } });
    } else if (entity === 'delivery' || entity === 'shipment') {
      //navigate('/bb/app/deliveryfullfillmentflow', { state: { shipment_id: entityId, activeTab:'deliverys' } });
      navigate('/bb/app/home', { state: { order_id: entityId, activeTab:'deliverys' } });
    } else if (entity === 'bp' || entity === 'moq' || entity === 'mov' || entity === 'vendor_price' || entity === 'discount_slab') {
      navigate('/bb/app/reports/productpricereports', { state: { _id: entityId, entity:entity } });
    }
     else {
      // default: open order fulfillment flow with id
      navigate('/bb/app/home', { state: { id: entityId, activeTab:'overview' } });
    }  

    // Remove this notification from list after action only when it's a real action (not just a simple "view")
    if (typeof setNotifications === 'function') {
      const actionLabel = (action.requiresAction || '').toString().toLowerCase();
      if (actionLabel === 'respond now' || actionLabel === 'submit quote') {
        setNotifications((prev) => prev.filter(n => n !== raw));
      }
    }
    // stop loader after short delay (component may unmount on navigate)
    setTimeout(() => stopLoading(action.id), 800);
  };

 const acceptRejectBestPrice = async (action, acceptValue) => {
  console.log(action)

  try {

    startLoading(action.id);

      const fetchURL = process.env.REACT_APP_FORE_BRICKBUCKET;


    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const notification_id = action.raw._id || null;
   const quotation_id =
  action?.raw?.metadata?.quotation_id ||
  action?.raw?.data?.metadata?.quotation_id ||
  null;

  console.log(acceptValue,quotation_id)
/*     if (!quotation_id) {
      setPopupMessage("Quotation ID not found");
      setPopupType("400");
      setShowPopupMessages(true);
      stopLoading(action.id);
      return;
    } */

    const response = await fetch(
      `${fetchURL}customer/quotations/accept-or-reject-best-prices`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify({
          accept: acceptValue,
          quotation_id: quotation_id,
          notification_id:notification_id
        })
      }
    );
    console.log("Request body:", {
      accept: acceptValue,
      quotation_id: quotation_id
    });

    console.log("accept/reject response:", response);

    const data = await response.json();

    if (response.ok) {

      setPopupMessage(data.message || "Success");
      setPopupType("200or201");
      setShowPopupMessages(true);
       setTimeout(() => {
        setShowPopupMessages(false);
      }, 3000);


      // remove notification
      setNotifications(prev =>
        prev.filter(n => n !== action.raw)
      );

    } else {

      setPopupMessage(data.message || "Failed");
      setPopupType("400");
      setShowPopupMessages(true);

    }

  } catch (err) {

    setPopupMessage(err.message || "Error occurred");
    setPopupType("500");
    setShowPopupMessages(true);

  } finally {

    stopLoading(action.id);

  }
};

const handleAccept = (action) => {
  acceptRejectBestPrice(action, true);
};

const handleDismiss = (action) => {
  acceptRejectBestPrice(action, false);
};


 return (  
  <div className="border rounded-lg p-1 shadow-sm h-full flex flex-col border-l-4 border-l-blue-400 shadow-md">
    <div className="p-3 mx-1 border-b flex items-center justify-between min-h-[70px]">
      <div className="flex-1 min-w-0">
        <h3 className="text-lg font-semibold text-[#0F172A]">Action Center</h3>
        <p className="text-gray-500 text-xs mt-1 truncate font-medium">{actions.length} notifications requires attention</p>
      </div>
      <span className="inline-flex items-center justify-center  bg-[#E0F2FE] text-blue-600  px-3 py-1.5 rounded-md font-medium text-sm whitespace-nowrap flex-shrink-0 min-w-[40px]">
        {refreshing ? 'Refreshing...' : actions.length}
      </span>
    </div>

    <div className="flex-1 overflow-y-auto p-2 space-y-3">  
      {refreshing && (
        <div className="text-center text-gray-500 py-8">
       <div className=" flex space-x-2  justify-center items-center h-20 ">
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.3s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
    </div>
          </div>
      )}
      {!refreshing && actions.length === 0 && (
        <div className="text-center text-gray-500 py-8">No pending actionable notifications</div>
      )}

      {actions.map(action => (
        <div key={action.id} className="bg-white rounded-lg p-3 text-sm border border-gray-200 flex items-start gap-2 shadow-md hover:shadow-md transition border-l-4 border-l-gray-200">
          <div className={`p-0 rounded-md flex-shrink-0 color-gray-600`}>
            {getIcon(action.entity)}
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-1">
              <p className="font-medium text-sm">{action.title}</p>

            </div>

            <p className="text-gray-500 text-[13px] mb-2 mt-1">{action.description}</p>


{['bp', 'mov', 'moq', 'vendor_price', 'discount_slab'].includes(action.entity?.toLowerCase()) ? (

  <div className="flex gap-2 w-full">

    {/* VIEW BUTTON */}
    <button
      onClick={() => handleAction(action)}
      disabled={isLoading(action.id)}
      className="flex-1 border border-blue-500 text-blue-600 px-2 py-1.5 text-xs font-medium rounded hover:bg-blue-600 hover:text-white disabled:opacity-50 flex items-center justify-center gap-1"
    >
      {isLoading(action.id) ? "Loading..." : "View"}
      <FontAwesomeIcon icon={faChevronRight} className="text-[10px]" />
    </button>

    {/* DISMISS BUTTON */}
    <button
      onClick={() => handleDismiss(action)}
      disabled={isLoading(action.id)}
      className="flex-1 border border-gray-400 text-gray-600 px-2 py-1.5 text-xs font-medium rounded hover:bg-gray-600 hover:text-white disabled:opacity-50"
    >
      Dismiss
    </button>

  </div>

) : action.entityId ? (

  // Default behavior (RFQ / Order / Delivery etc.)
  <button
    onClick={() => handleAction(action)}
    className="w-full border border-red-500 text-black font-medium px-2 py-1.5 text-xs rounded hover:bg-red-700 hover:text-white transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
    disabled={isLoading(action.id) || refreshing}
  >
    {isLoading(action.id) ? (
      <>
        <svg className="animate-spin h-4 w-4 text-gray-400" viewBox="0 0 24 24" />
        Loading...
      </>
    ) : (
      <>
        {action.requiresAction}
        <FontAwesomeIcon icon={faChevronRight} className="text-[10px]" />
      </>
    )}
  </button>

) : null}


          </div>
        </div>
      ))}
    </div>

    {showPopupMessages &&
  createPortal(
    <div className="fixed inset-0 z-[99999]">
      {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
      {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
      {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
      {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
      {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
      {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
    </div>,
    document.body
  )
}

  </div>
);

} 
